module.exports = __webpack_public_path__ + "media/images/promo/community-e379c31d23efdd69c9b4e83ce1f445494725ce4191114210549eca9763957e7d.png";